<!-- For All users -->
<div class="card">
  <div class="card-header">
    {{ 'DATE' | translate}}: {{_resourceService.selectedFreeslot?.date | date:"dd/MM/yyyy" }} |
    {{ 'HOUR' | translate}}:
    {{_resourceService.selectedFreeslot?.hour}}
  </div>
  <div class="card-body">
    <h5 class="card-title"
      *ngIf="_resourceService.selectedFreeslot && _resourceService.selectedFreeslot?.doctor">
      {{_resourceService.selectedFreeslot?.doctor?.name}}
    </h5>
    <h5 class="card-title"
      *ngIf="_resourceService.selectedFreeslot && _resourceService.selectedFreeslot?.roomName">
      {{_resourceService.selectedFreeslot?.roomName}}
    </h5>
    <p class="card-text" *ngIf="_resourceService.selectedFreeslot?.hospital?.name">
      {{ 'HOSPITAL' | translate}}:
      {{_resourceService.selectedFreeslot?.hospital.name }}
    </p>
    <p class="card-text" *ngIf="_resourceService.selectedFreeslot?.department?.name">
      {{ 'DEPARTMENT' | translate}}:
      {{_resourceService.selectedFreeslot?.department?.name }}
    </p>
    <p class="card-text" *ngIf="_resourceService.selectedFreeslot?.doctor?.personalData?.address">
      {{ 'ADDRESS' | translate}}:
      {{_resourceService.selectedFreeslot?.doctor?.personalData?.address}}
    </p>
    <p class="card-text"
      *ngIf="_resourceService.selectedFreeslot?.doctor?.personalData?.flatNumber">
      {{ 'FLAT_NUMBER' | translate}}:
      {{_resourceService.selectedFreeslot?.doctor?.personalData?.flatNumber}}
    </p>
    <p class="card-text"
      *ngIf="_resourceService.selectedFreeslot?.treatment?.name &&
    _resourceService.selectedFreeslot?.treatment?.id != _resourceService.selectedFreeslot?.department?.id">
      {{ 'OUTPATIENT_CLINIC' | translate}}:
      {{_resourceService.selectedFreeslot?.treatment?.name }}
    </p>
    <p class="card-text" *ngIf="_resourceService.selectedFreeslot?.payorName">
      {{ 'SOURCE_OF_FUNDING' | translate}}:
      {{ _resourceService.selectedFreeslot?.payorName }}
    </p>


    <!-- Campos optativos -->

    <p class="card-text" *ngIf="optionalFieldsForSlots.NOTIFICATIONS">
      {{ 'NOTIFICATIONS' | translate}}:

      <span class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="email"
          [disabled]="disableNotificatoins">
        <label class="custom-control-label" for="email">{{ 'EMAIL' | translate}}</label>
      </span>
      <span class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="sms"
          [disabled]="disableNotificatoins">
        <label class=" custom-control-label" for="sms">{{ 'SMS' | translate}}</label>
      </span>
    </p>
    <div class="form-group" *ngIf="optionalFieldsForSlots.COMENTS">
      <label for="comments">{{ 'COMMENTS' | translate}}:</label>
      <textarea class="form-control" rows="5" id="comments"></textarea>
    </div>

  </div>
</div>